import React from 'react';
import PropTypes from 'prop-types';

const FormGroup = ({ children }) => (
    <fieldset className="form-group">
        {children}
    </fieldset>
);

export default FormGroup;